export default {
  logs: {
    columnUserName: "Nombre de usuario",
    columnStartDateTime: "Fecha de inicio",
    columnEndDateTime: "Fecha de finalización",
    columnAction: "Acción",
    columnComment: "Comentario",
    textAreaObservation: "Comentario detallado de la acción seleccionada",
    log: "Log",
    tittleDialog: "Log de flujo de trabajo",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/createNewMaterials/Stages/logs.js